import React, { useEffect, useState, useContext } from 'react';
import Header from '../Header/AppHeader';
import Axiosfetch from '../Common/Axiosfetch';
import Alert from 'react-s-alert';
import moment from 'moment';
import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/slide.css';
import baseURL from '../Common/Config';
import { ContextMenu, MenuItem, ContextMenuTrigger } from "react-contextmenu";
import ReactTooltip from "react-tooltip";
import { ThemeContext } from '../Common/ThemeProvider';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DatePicker from 'react-datepicker';
import { faArrowLeft, faArrowRight, faCalendarPlus, faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import FailureAlert from '../Common/Failure';

const LeaveData = {
    Name: "",
    HolidayDay: 0,
    HolidayMonth: 0,
    HolidayYear: 0,
    LeaveType: 0,
};

const LeaveTypeData = [
    { type: 1, Name: "Casual Leave" },
    { type: 2, Name: "Sick Leave" },
    { type: 3, Name: "Loss of Pay" }
];

const UserLeaves = () => {
    const { CurrentTheme } = useContext(ThemeContext);

    const [DaysInAMonth, setDaysInAMonth] = useState([]);
    const [Holidays, setHolidays] = useState([]);
    const [Leaves, setLeaves] = useState([]);
    const [LeavesData, setLeavesData] = useState(LeaveData);
    const [currentMonth, setcurrentMonth] = useState(moment().month() + 1);
    const [Role, setRole] = useState(0);
    const [displayLeaves, setdisplayLeaves] = useState("none");
    const [displayApplyLeaves, setdisplayApplyLeaves] = useState("none");
    const [displayHolidays, setdisplayHolidays] = useState("none");
    const [displayLeaveList, setdisplayLeaveList] = useState("none");
    const [endDate, setendDate] = useState(new Date());
    const [startDate, setstartDate] = useState(new Date());
    const [selectedLeaveType, setSelectedLeaveType] = useState(0);
    const [HolidaTypeInfo, setHolidaTypeInfo] = useState([]);
    const [LeaveInfo, setLeaveInfo] = useState([]);


    const GetMonthDays = (month) => {
        var daysArray = [];
        var days = moment(moment().year().toString() + "-" + month).daysInMonth();
        for (var i = 1; i <= parseInt(days); i++) {
            var dayName = moment(moment().year() + "-" + month + "-" + i).format('ddd');
            var day = moment(moment().year() + "-" + month + "-" + i).day();
            var IsWeekend = (day === 0);
            daysArray.push({ DayNumber: i, DayName: dayName, WeekEnd: IsWeekend });
        }

        setDaysInAMonth(daysArray);

        var userData = localStorage.getItem("userData") ? localStorage.getItem("userData") : null;
        if (userData) {
            setRole(parseInt(JSON.parse(userData).Role.ID));
        }
    };

    const FetchHolidaysData = () => {
        Axiosfetch(baseURL + "GetHolidayInfo", "GET", null, HolidaySuccess, Failure);
    };

    const HolidaySuccess = (data) => {
        if (data.length > 0) {
            setHolidays(data);
        }

        FetchLeaves();
    };

    const FetchLeaves = () => {
        var userData = localStorage.getItem("userData") ? localStorage.getItem("userData") : null;
        const userID = parseInt(JSON.parse(userData).ID);
        Axiosfetch(baseURL + "GetLeaveInfoByUserID", "POST", { UserID: userID, LeaveYear: moment().year() }, LeavesSuccess, Failure);
    };

    const LeavesSuccess = (data) => {
        if (data.length > 0) {
            setLeaves(data);
        }
    };

    const Failure = (err) => {
        FailureAlert(err);
    };


    const PrevMonth = () => {
        if (currentMonth > 1) {
            setcurrentMonth(currentMonth - 1);
            GetMonthDays((currentMonth - 1));

        }
    };

    const NextMonth = () => {
        if (currentMonth < 12) {
            setcurrentMonth(currentMonth + 1);
            GetMonthDays((currentMonth + 1));
        }
    };

    const ShowApplyLeavesModel = () => {
        setdisplayApplyLeaves("block");
    };

    const ShowHolidaysModel = (holidayType) => {
        if (holidayType !== 3) {
            var holidayList = Holidays.filter(h => h.LeaveType === holidayType);
            if (holidayList.length > 0) {
                setHolidaTypeInfo(holidayList);
                setdisplayHolidays("block");
            }
            else {
                setdisplayHolidays("none");
            }
        }
        else {
            if (Leaves.length > 0) {
                setLeaveInfo(Leaves);
                setdisplayLeaveList("block");
            }
            else {
                setdisplayLeaveList("none");
            }
        }
    };

    const HideHolidaysModel = () => {
        setdisplayHolidays("none");
    };

    const hideApplyLeavesModel = () => {
        setdisplayApplyLeaves("none");
    };

    const onStartDateChange = (date) => {
        setstartDate(date);
    };

    const onEndDateChange = (date) => {
        setendDate(date);
    };

    const handleClick = (e, data) => {
        if (data.m === '1' || data.m === '2') {
            const Holiday = {
                Name: "",
                Description: null,
                HolidayDay: parseInt(data.day),
                HolidayMonth: parseInt(data.month),
                HolidayYear: parseInt(moment().year()),
                LeaveType: parseInt(data.m),
                CreatedDate: moment(new Date())
            };

            setLeavesData(Holiday);
            setdisplayLeaves("block");
        }
        if (data.m === '3') {
            DeleteHoliday(parseInt(data.holidayID));
        }

        if (data.m === '4') {
            DeleteLeave(parseInt(data.leaveID));

        }
    };

    const onHolidayNameChange = (e) => {
        setLeavesData({ ...LeavesData, [e.target.name]: e.target.value });
    };

    const hideLeavesModel = () => {
        setdisplayLeaves("none");
    };

    const HideLeaveListModel = () => {
        setdisplayLeaveList("none");
    }

    const SaveLeavesDetails = () => {
        CreateHoliday(LeavesData);
    };

    const SaveUserLeavesDetails = () => {

        if (parseInt(selectedLeaveType) > 0) {
            var startDateLeave = startDate;
            var endDateLeave = new Date(endDate).setMinutes(endDate.getMinutes() + 1);
            var leavePlan = [];
            var userData = localStorage.getItem("userData") ? localStorage.getItem("userData") : null;
            const userID = parseInt(JSON.parse(userData).ID);
            while (startDateLeave <= endDateLeave) {
                const Holiday = {
                    Name: "Employee Leaves",
                    Description: null,
                    UserID: userID,
                    LeaveDay: parseInt(moment(new Date(startDateLeave)).format('D')),
                    LeaveMonth: parseInt(moment(startDateLeave).format('M')),
                    LeaveYear: parseInt(moment(startDateLeave).year()),
                    LeaveType: parseInt(selectedLeaveType),
                    CreatedDate: moment(new Date()),
                    Status: 1,
                    IsDeleted: 0
                };

                if (moment(new Date(startDateLeave)).day() !== 0 &&
                    // moment(new Date(startDateLeave)).day() !== 6 &&

                    Holidays.filter(h => h.HolidayDay === Holiday.LeaveDay &&
                        h.HolidayMonth === Holiday.LeaveMonth
                        && h.HolidayYear === Holiday.LeaveYear).length === 0 &&

                    Leaves.filter(h => h.LeaveDay === Holiday.LeaveDay &&
                        h.LeaveMonth === Holiday.LeaveMonth
                        && h.LeaveYear === Holiday.LeaveYear).length === 0) {
                    leavePlan.push(Holiday);
                }

                startDateLeave = moment(new Date(startDateLeave)).add('days', 1);
            };

            if (leavePlan.push.length > 0) {
                Axiosfetch(baseURL + "CreateLeave", "POST", leavePlan, LeaveAPISuccess, Failure);
            }
        }
        else {
            Alert.error("Please select Leave Type", {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const LeaveAPISuccess = (data) => {
        Alert.success(data, {
            position: 'bottom-right',
            effect: 'slide',
            html: false
        });

        setdisplayApplyLeaves("none");
        FetchHolidaysData();
    };

    const CreateHoliday = (HolidayData) => {
        if (HolidayData.Name !== "") {
            Axiosfetch(baseURL + "CreateHoliday", "POST", HolidayData, HolidayAPISuccess, Failure);
        }
        else {
            Alert.error("Enter Holiday Name", {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    }

    const DeleteHoliday = (HolidayID) => {
        Axiosfetch(baseURL + "DeleteHoliday", "POST", { ID: HolidayID }, HolidayAPISuccess, Failure);
    };

    const DeleteLeave = (LeaveID) => {
        Axiosfetch(baseURL + "DeleteLeaves", "POST", { ID: LeaveID }, HolidayAPISuccess, Failure);
    };

    const HolidayAPISuccess = (data) => {
        Alert.success(data, {
            position: 'bottom-right',
            effect: 'slide',
            html: false
        });

        setdisplayLeaves("none");
        FetchHolidaysData();
    };

    useEffect(() => {
        GetMonthDays(currentMonth);
        FetchHolidaysData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div>
            <Header></Header>
            <div className="container-fluid InvoiceTheme shadow sidemenu-show">
                <div className="row">
                    <div className="offset-md-2 col-md-2 align-left font-size-15rem">
                        <span className="cursor" onClick={PrevMonth}> <FontAwesomeIcon icon={faArrowLeft} /></span>
                        <span style={{ marginLeft: "15px", opacity: "0.8" }}>{moment().month(currentMonth - 2).startOf('month').format('MMMM')}</span>
                    </div>
                    <div className="col-md-4 align-center">
                        <h5 style={{ fontWeight: "600" }}>{moment().month(currentMonth - 1).startOf('month').format('MMMM') + " " + moment().year()}</h5>
                    </div>
                    <div className="col-md-2 align-right font-size-15rem">
                        <span style={{ marginRight: "15px", opacity: "0.8" }}>{moment().month(currentMonth).startOf('month').format('MMMM')}</span>
                        <span className="cursor" onClick={NextMonth}> <FontAwesomeIcon icon={faArrowRight} /></span>
                    </div>
                    <div className="offset-md-1 col-md-1 align-center font-size-15rem" style={{ opacity: "0.8" }}>
                        <span data-tip="Apply Leaves" className="cursor" onClick={ShowApplyLeavesModel}> <FontAwesomeIcon icon={faCalendarPlus} /></span>
                    </div>

                </div>
                <div className="row" style={{ padding: "15px", justifyContent: "center" }}>

                    {DaysInAMonth.map(day => (
                        <div key={parseInt(day.DayNumber)}>
                            <ContextMenu id={day.DayNumber.toString()}>
                                {(Role === 1 && !day.WeekEnd) &&
                                    (Holidays.filter(h => h.HolidayDay === parseInt(day.DayNumber) &&
                                        h.HolidayMonth === parseInt(currentMonth) &&
                                        h.HolidayYear === parseInt(moment().year())).length === 0 &&

                                        Leaves.filter(h => h.LeaveDay === parseInt(day.DayNumber) &&
                                            h.LeaveMonth === parseInt(currentMonth) &&
                                            h.LeaveYear === parseInt(moment().year())).length === 0) &&
                                    <MenuItem data={{
                                        m: '1', month: currentMonth.toString(),
                                        day: day.DayNumber.toString()
                                    }} onClick={handleClick}>
                                        Add National Holiday
                                         </MenuItem>}
                                {(Role === 1 && !day.WeekEnd) &&
                                    (Holidays.filter(h => h.HolidayDay === parseInt(day.DayNumber) &&
                                        h.HolidayMonth === parseInt(currentMonth) &&
                                        h.HolidayYear === parseInt(moment().year())).length === 0 &&

                                        Leaves.filter(h => h.LeaveDay === parseInt(day.DayNumber) &&
                                            h.LeaveMonth === parseInt(currentMonth) &&
                                            h.LeaveYear === parseInt(moment().year())).length === 0) &&
                                    <MenuItem data={{
                                        m: '2', month: currentMonth.toString(),
                                        day: day.DayNumber.toString()
                                    }}
                                        onClick={handleClick}>
                                        Organization Holiday
                                         </MenuItem>}
                                {(Role === 1 && !day.WeekEnd) && (Holidays.filter(h => h.HolidayDay === parseInt(day.DayNumber) && h.HolidayMonth === parseInt(currentMonth) && h.HolidayYear === parseInt(moment().year())).length > 0) &&
                                    <MenuItem data={{
                                        m: '3',
                                        holidayID: Holidays.filter(h => h.HolidayDay === parseInt(day.DayNumber) &&
                                            h.HolidayMonth === parseInt(currentMonth) &&
                                            h.HolidayYear === parseInt(moment().year()))[0].ID.toString(),
                                        month: currentMonth.toString(), day: day.DayNumber.toString()
                                    }}
                                        onClick={handleClick}>
                                        Remove Holiday
                                            </MenuItem>}

                                {!day.WeekEnd && (Leaves.filter(h => h.LeaveDay === parseInt(day.DayNumber) &&
                                    h.LeaveMonth === parseInt(currentMonth) &&
                                    h.LeaveYear === parseInt(moment().year())).length > 0) &&
                                    <MenuItem data={{
                                        m: '4',
                                        leaveID: Leaves.filter(h => h.LeaveDay === parseInt(day.DayNumber) &&
                                            h.LeaveMonth === parseInt(currentMonth) &&
                                            h.LeaveYear === parseInt(moment().year()))[0].ID.toString(),
                                        month: currentMonth.toString(), day: day.DayNumber.toString()
                                    }}
                                        onClick={handleClick}>
                                        Remove Leave
                                            </MenuItem>}
                            </ContextMenu>
                            <ContextMenuTrigger id={day.DayNumber.toString()}>
                                <div className={((Holidays.filter(h => h.HolidayDay === parseInt(day.DayNumber)
                                    && h.HolidayMonth === parseInt(currentMonth) &&
                                    h.HolidayYear === parseInt(moment().year())).length === 0 &&
                                    Leaves.filter(h => h.LeaveDay === parseInt(day.DayNumber)
                                        && h.LeaveMonth === parseInt(currentMonth) &&
                                        h.LeaveYear === parseInt(moment().year())).length === 0) ?
                                    "CalenderDates" : "")}
                                    id={day.DayNumber.toString()} key={day.DayNumber}
                                    data-tip={((Holidays.filter(h => h.HolidayDay === parseInt(day.DayNumber)
                                        && h.HolidayMonth === parseInt(currentMonth) &&
                                        h.HolidayYear === parseInt(moment().year())).length > 0) ? "Holiday - " +
                                        Holidays.filter(h => h.HolidayDay === parseInt(day.DayNumber) &&
                                            h.HolidayMonth === parseInt(currentMonth) &&
                                            h.HolidayYear === parseInt(moment().year()))[0].Name
                                        : (Leaves.filter(h => h.LeaveDay === parseInt(day.DayNumber)
                                            && h.LeaveMonth === parseInt(currentMonth) &&
                                            h.LeaveYear === parseInt(moment().year())).length > 0) ? "Employee Leave - " +
                                            LeaveTypeData.filter(l => l.type ===
                                                Leaves.filter(h => h.LeaveDay === parseInt(day.DayNumber)
                                                    && h.LeaveMonth === parseInt(currentMonth) &&
                                                    h.LeaveYear === parseInt(moment().year()))[0].LeaveType)[0].Name : "")}
                                    style={{
                                        border: ((Holidays.filter(h => h.HolidayDay === parseInt(day.DayNumber) &&
                                            h.HolidayMonth === parseInt(currentMonth) &&
                                            h.HolidayYear === parseInt(moment().year())).length > 0) ?
                                            ((Holidays.filter(h => h.HolidayDay === parseInt(day.DayNumber) &&
                                                h.HolidayMonth === parseInt(currentMonth) &&
                                                h.HolidayYear === parseInt(moment().year()))[0].LeaveType === 1 ?
                                                "2px solid orange" : "2px solid #005582")) :

                                            (Leaves.filter(h => h.LeaveDay === parseInt(day.DayNumber)
                                                && h.LeaveMonth === parseInt(currentMonth) &&
                                                h.LeaveYear === parseInt(moment().year())).length > 0) ? "2px solid #329932" :
                                                "1px solid #ccc"),

                                        //     backgroundColor: ((Holidays.filter(h => h.HolidayDay === parseInt(day.DayNumber) &&
                                        // h.HolidayMonth === parseInt(currentMonth) &&
                                        // h.HolidayYear === parseInt(moment().year())).length > 0) ?
                                        // ((Holidays.filter(h => h.HolidayDay === parseInt(day.DayNumber) &&
                                        //     h.HolidayMonth === parseInt(currentMonth) &&
                                        //     h.HolidayYear === parseInt(moment().year()))[0].LeaveType === 1 ?
                                        //     "#fff6e5" : "#e5eef2")) :

                                        // (Leaves.filter(h => h.LeaveDay === parseInt(day.DayNumber)
                                        //     && h.LeaveMonth === parseInt(currentMonth) &&
                                        //     h.LeaveYear === parseInt(moment().year())).length > 0) ? "#cce5cc" :
                                        //     ""),

                                        borderRadius: "12px", width: "10rem", margin: "5px",
                                        padding: "17px", textAlign: "center"
                                    }}><span style={{ marginLeft: "25px" }}>{day.DayNumber}</span>
                                    <span className="dayNameStyle">{day.DayName}</span>
                                </div>

                                <ReactTooltip></ReactTooltip>
                            </ContextMenuTrigger>
                        </div>
                    ))}
                </div>
                <div className="row" style={{ textAlign: "center", color: "white", padding: "10px 20px 10px 20px" }}>
                    <div className="col-md-4" style={{ backgroundColor: "orange", padding: "10px" }}>National Holiday
                    <div className="align-left font-size-15rem" style={{ opacity: "0.8" }}>
                            <span data-tip="Holidays" className="cursor" onClick={(holidayID) => ShowHolidaysModel(1)}> <FontAwesomeIcon icon={faCalendarAlt} /></span>
                        </div>
                    </div>
                    <div className="col-md-4" style={{ backgroundColor: "#005582", padding: "10px" }}>Organization Holiday
                    <div className="align-left font-size-15rem" style={{ opacity: "0.8" }}>
                            <span data-tip="Holidays" className="cursor" onClick={(holidayID) => ShowHolidaysModel(2)}> <FontAwesomeIcon icon={faCalendarAlt} /></span>
                        </div>
                    </div>
                    <div className="col-md-4" style={{ backgroundColor: "green", padding: "10px" }}>Employee Leaves
                    <div className="align-left font-size-15rem" style={{ opacity: "0.8" }}>
                            <span data-tip="Holidays" className="cursor" onClick={(holidayID) => ShowHolidaysModel(3)}> <FontAwesomeIcon icon={faCalendarAlt} /></span>
                        </div>
                    </div>
                </div>
            </div>

            <div id="Leaves" className="modal" style={{ display: displayLeaves }}>
                <div className="modal-content">
                    <div className={`modal-header header-style align-center ${CurrentTheme}`}>
                    <span style={{ marginLeft: "5px", padding:"5px" }}>Add Holiday</span>
                        <span className="close" onClick={hideLeavesModel}>&times;</span>
                    </div>
                    <table className="table">
                        <tbody>
                            <tr style={{ textAlign: "center" }}>
                                <td colSpan="2">
                                    <h5>Date - {moment(LeavesData.HolidayYear + "-" + LeavesData.HolidayMonth + "-" + LeavesData.HolidayDay).format('DD MMMM YYYY')}</h5>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <h5>Holiday Name</h5>
                                </td>
                                <td>
                                    <input type="text" min="0" name="Name"
                                        className="form-control" onChange={e => onHolidayNameChange(e)}
                                        value={LeavesData.Name}></input>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ textAlign: "right" }} colSpan="2">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <button type="button" style={{ fontSize: "1.4rem" }} className={`btn btn-Save ${CurrentTheme}Focus`} onClick={SaveLeavesDetails}>Save</button>
                                            <button type="button" className="btn btn-default" onClick={hideLeavesModel}>Close</button>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div id="ApplyLeavesModel" className="modal" style={{ display: displayApplyLeaves }}>
                <div className="modal-content">
                    <div className={`modal-header header-style align-center ${CurrentTheme}`}>
                    <span style={{ marginLeft: "5px", padding:"5px" }}>Add Leaves</span>
                        <span className="close" onClick={hideApplyLeavesModel}>&times;</span>
                    </div>
                    <table className="table">
                        <tbody>
                            <tr>
                                <td>
                                    <h5>Start Date<span className="mandatoryStar">*</span></h5>
                                </td>
                                <td>
                                    <DatePicker selected={startDate}
                                        onChange={onStartDateChange}
                                        className="form-control"
                                        dateFormat="MMMM d, yyyy"></DatePicker>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <h5>End Date<span className="mandatoryStar">*</span></h5>
                                </td>
                                <td>
                                    <DatePicker selected={endDate}
                                        onChange={onEndDateChange}
                                        className="form-control"
                                        dateFormat="MMMM d, yyyy"></DatePicker>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <h5>Leave Type<span className="mandatoryStar">*</span></h5>
                                </td>
                                <td>
                                    <div className="basic-select">
                                        <select className="DropdownStyle" value={selectedLeaveType} style={{ width: "90%" }} onChange={(e) => setSelectedLeaveType(e.target.value)}>
                                            <option value="0">Select Leave Type</option>
                                            {
                                                LeaveTypeData.length && LeaveTypeData.map(leave => (
                                                    <option key={leave.type} value={leave.type}>{leave.Name}</option>
                                                )
                                                )
                                            }
                                        </select>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ textAlign: "right" }} colSpan="2">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <button type="button" style={{ fontSize: "1.4rem" }} className={`btn btn-Save ${CurrentTheme}Focus`} onClick={SaveUserLeavesDetails}>Apply</button>
                                            <button type="button" className="btn btn-default" onClick={hideApplyLeavesModel}>Close</button>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div id="HolidaysModel" className="modal" style={{ display: displayHolidays }}>
                <div className="modal-content">
                    <div className={`modal-header header-style align-center ${CurrentTheme}`}>
                    <span style={{ marginLeft: "5px", padding:"5px" }}>Holidays</span>
                        <span className="close" onClick={HideHolidaysModel}>&times;</span>
                    </div>
                    <div className="col-md-12 tableQuotationRecordsStyle">
                        <table className="table table-striped">
                            <thead className="StickyHeader">
                                <tr>
                                    <th className={`align-center`}>Name</th>
                                    <th className={`align-center`}>Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                {HolidaTypeInfo.length > 0 && HolidaTypeInfo.map(holiday => (
                                    <tr key={holiday.ID} className="textCenter">
                                        <td>{holiday.Name}</td>
                                        <td>{moment(holiday.HolidayYear + "-" + holiday.HolidayMonth + "-" + holiday.HolidayDay).local().format("DD MMM YYYY")}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div id="LeaveListModel" className="modal" style={{ display: displayLeaveList }}>
                <div className="modal-content">
                    <div className={`modal-header header-style align-center ${CurrentTheme}`}>
                    <span style={{ marginLeft: "5px", padding:"5px" }}>Holidays</span>
                        <span className="close" onClick={HideLeaveListModel}>&times;</span>
                    </div>
                    <div className="col-md-12 tableQuotationRecordsStyle">
                        <table className="table table-striped">
                            <thead className="StickyHeader">
                                <tr>
                                    <th className={`align-center`}>Name</th>
                                    <th className={`align-center`}>Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                {LeaveInfo.length > 0 && LeaveInfo.map(holiday => (
                                    <tr key={holiday.ID} className="textCenter">
                                        <td>{Leaves.filter(h => h.LeaveDay === parseInt(holiday.LeaveDay)
                                            && h.LeaveMonth === parseInt(holiday.LeaveMonth) &&
                                            h.LeaveYear === parseInt(holiday.LeaveYear)).length > 0 && LeaveTypeData.filter(l => l.type ===
                                                Leaves.filter(h => h.LeaveDay === parseInt(holiday.LeaveDay)
                                                    && h.LeaveMonth === parseInt(holiday.LeaveMonth) &&
                                                    h.LeaveYear === parseInt(holiday.LeaveYear))[0].LeaveType)[0].Name}</td>
                                        <td>{moment(holiday.LeaveYear + "-" + holiday.LeaveMonth + "-" + holiday.LeaveDay).local().format("DD MMM YYYY")}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UserLeaves;